<template>
  <section @click="stopShow($event)"
           id="multipleSelect"
           class="multipleSelectFather">
    <section :id="randomId + 'father'"
             :style="{'max-width': width ? width + '!important' : '','min-width': width ? width + '!important' : ''}"
             class="multipleSelect">
      <section>
        <section
          :style="{'background': newDisabled ? '#F5F5F5' : '','cursor':newDisabled? ' no-drop': 'pointer','border':newDisabled?'1px solid #F5F5F5':'1px solid #B62A40'}"
          :title="placeholder"
          @click="showDropFun"
          v-if="submitValue === ''"
          style="color: #ccc;font-size: 12px"
          class="multipleSelectShowPlace">{{chooseData.length > 0?placeholder:$t('common.noData')}}
        </section>
        <section
          :style="{'background': newDisabled ? '#F5F5F5' : '','cursor':newDisabled? ' no-drop': 'pointer','border':newDisabled?'1px solid #F5F5F5':'1px solid #B62A40'}"
          :title="submitValue"
          v-else
          @click="showDropFun"
          class="multipleSelectShowPlace"
          style="font-size: 12px">
          <div class="noWrap">{{submitValue}}</div>
        </section>
      </section>
      <i @click="showDropFun"
         class="icon iconfont icon-sanjiaojiantou-xia multipleSelectArror"></i>
      <section :id="randomId"
               class="multipleSelectDrop" :style="showCols==1?'width:100%':''">
        <section v-if="shownothing"
                 disabled="disabled"
                 class="multipleSelectSelectData">{{$t('common.NoValueFound')}}
        </section>
        <section
          style="position: absolute;bottom: 0;width:100%;display: flex;align-items: center;border-top: 1px solid #e5e5e5;">
          <section style="padding: 6px 10px;text-decoration: underline;color: #C73343;cursor:pointer;"
                   @click="confirmData()"> {{$t('common.Ok')}}
          </section>
          <section @click="seltData(item)"
                   class="multipleSelectSelectData"
                   :key="index"
                   v-if="index == 0"
                   v-for="(item, index) in selectData"
                   style="font-size: 12px;width: 60%;">
<!--            <input type="checkbox"-->
<!--                   :checked="item.checked ? true : false"/>-->
<!--            <div style="white-space: normal;text-overflow: ellipsis;width: 90%;">{{returnShowValue(item)}}（清除筛选）</div>-->
            <section style="text-decoration: underline;color: #666;cursor:pointer;"
                     @click="returnShowValue(item)"> {{$t('common.ClearFilter')}}
            </section>
          </section>
        </section>
        <section style="max-height: 165px;overflow: auto;margin-bottom: 37px;">
          <section @click="seltData(item)"
                   class="multipleSelectSelectData"
                   :key="index"
                   v-if="index > 0"
                   v-for="(item, index) in selectData"
                   :style="showCols==1?'width:calc(100% - 12px);font-size:12px':'font-size:12px'">
            <input type="checkbox"
                   :checked="item.checked ? true : false"/>
            <div style="white-space: normal;text-overflow: ellipsis;width: 90%;">{{returnShowValue(item)}}</div>
          </section>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
let array = []
export default {
  name: 'hospitalSelect',
  model: {
    prop: 'selectValue',
    event: 'selectValue'
  },
  props: [
    'selectValue',
    'chooseData',
    'needReturn',
    'showValue',
    'matchValue',
    'placeholder',
    'width',
    'disabled',
    'item',
    'cols'
  ],
  data () {
    return {
      shownothing: false,
      newDisabled: this.disabled,
      randomId: 'selectId' + new Date().getTime() + Math.random() * 1000,
      newSelectValue: this.selectValue,
      showSelectValue: '',
      submitValue: '',
      selectData: this.chooseData,
      showCols: this.cols || 2
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    array = []
    this.handleData()
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    document.getElementById('index').addEventListener('click', closetab)
  },
  destroyed () {
    document.getElementById('index').removeEventListener('click', closetab)
  },
  methods: {
    handleData () {
      this.showSelectValue = ''
      let splitValue = (this.newSelectValue === '' || this.newSelectValue === null || this.newSelectValue === undefined) ? [''] : this.newSelectValue.toString().split(',')
      if (this.selectData) {
        for (let i = 0; i < this.selectData.length; i++) {
          this.$set(this.selectData[i], 'checked', false)
          for (let j = 0; j < splitValue.length; j++) {
            if (this.selectData[i][this.needReturn].toString() === splitValue[j]) {
              this.selectData[i].checked = true
              this.showSelectValue += this.selectData[i][this.matchValue] + ','
            }
          }
        }
        if (splitValue.length === 0 || (splitValue.length === 1 && splitValue[0] === 'undefined')) {
          this.selectData[0].checked = true
          this.showSelectValue = this.selectData[0][this.matchValue] + ','
        }
      }
      this.showSelectValue = this.showSelectValue.substring(0, this.showSelectValue.length - 1)
      let html = this.showValue
      getItem(html)
    },
    seltData (item) {
      let splitValue = (this.newSelectValue === '' || this.newSelectValue === null || this.newSelectValue === undefined) ? [''] : this.newSelectValue.toString().split(',')
      let splitshowSelectValue = this.showSelectValue === '' ? [] : this.showSelectValue.split(',')
      if (item[this.needReturn].toString() === '' && splitValue.length > 0) {
        splitValue = ['']
      }
      if (splitValue.indexOf(item[this.needReturn].toString()) >= 0) {
        splitValue.splice(splitValue.indexOf(item[this.needReturn].toString()), 1)
        splitshowSelectValue.splice(splitshowSelectValue.indexOf(item[this.needReturn].toString()), 1)
        let selectHmtl = ''
        // let selectHmtl2 = ''
        for (let i = 0; i < splitValue.length; i++) {
          selectHmtl += splitValue[i] + ','
          // selectHmtl2 += splitshowSelectValue[i] + ','
        }
        selectHmtl = selectHmtl.substring(0, selectHmtl.length - 1)
        // selectHmtl2 = selectHmtl2.substring(0, selectHmtl2.length - 1)
        this.newSelectValue = selectHmtl
        // this.showSelectValue = selectHmtl2
        // this.$emit('selectValue', this.newSelectValue)
        if (this.item) {
          item.object = this.item
        }
        this.$emit('on-change', item)
      } else {
        if (this.newSelectValue === '' || this.newSelectValue === undefined) {
          this.newSelectValue = item[this.needReturn]
        } else {
          this.newSelectValue += ',' + item[this.needReturn]
        }
        // this.$emit('selectValue', this.newSelectValue)
        if (this.item) {
          item.object = this.item
        }
        this.$emit('on-change', item)
        // if (this.showSelectValue === '') {
        //   this.showSelectValue += item[this.matchValue]
        // } else {
        //   this.showSelectValue += ',' + item[this.matchValue]
        // }
      }
      this.handleData()
    },
    confirmData () {
      this.submitValue = this.showSelectValue
      this.$emit('selectValue', this.newSelectValue)
      this.$emit('submit', this.showSelectValue)
      this.showDropFun()
    },
    showDropFun () {
      if (!this.newDisabled) {
        let dom = document.getElementById(this.randomId)
        let domList = document.querySelectorAll('.multipleSelectFather')
        for (let i = 0; i < domList.length; i++) {
          domList[i].style.zIndex = 1
        }
        dom.parentNode.parentNode.style.zIndex = 2
        if (dom.style.display === 'none' || dom.style.display === '') {
          let canderList = document.querySelectorAll('.multipleSelectDrop')
          if (canderList.length > 0) {
            for (let i = 0; i < canderList.length; i++) {
              canderList[i].style.display = 'none'
              canderList[i].style.opacity = '0'
            }
          }
          dom.style.display = 'block'
          setTimeout(p => {
            dom.style.opacity = '1'
          }, 10)
        } else {
          dom.style.opacity = '0'
          setTimeout(p => {
            dom.style.display = 'none'
          }, 200)
        }
      }
    },
    returnShowValue (object) {
      let html = this.showValue
      for (let i = 0; i < array.length; i++) {
        html = html.replace('{{' + array[i] + '}}', object[array[i]])
      }
      return html
    },
    stopShow (e) {
      e.stopPropagation()
    }
  },
  watch: {
    selectValue (value) {
      this.newSelectValue = value
      this.showSelectValue = ''
      this.handleData()
    },
    chooseData (value) {
      this.selectData = value
      this.handleData()
      this.submitValue = this.showSelectValue
    },
    disabled (value) {
      this.newDisabled = value
    }
  },
  computed: {}
}

function closetab () {
  let canderList = document.querySelectorAll('.multipleSelectDrop')
  if (canderList) {
    // for (let i = 0; i < canderList.length; i++) {
    //   canderList[i].style.opacity = '0'
    // }
    setTimeout(p => {
      for (let i = 0; i < canderList.length; i++) {
        canderList[i].style.display = 'none'
      }
    }, 200)
  }
}

function getItem (html) {
  if (html.indexOf('{{') >= 0) {
    let aPos = html.indexOf('{{')
    let bPos = html.indexOf('}}')
    let newName = html.substr(aPos + 2, bPos - aPos - 2)
    array.push(newName)
    html = html.replace('{{', '').replace('}}', '')
    getItem(html)
  }
}
</script>

<style scoped>
  .multipleSelectFather {
    position: relative;
  }

  .multipleSelect {
    position: relative;
    max-width: 180px;
    min-width: 180px;
    width: 100%;
    text-align: left;
    z-index: 5;
  }

  .multipleSelect .multipleSelectShowPlace {
    background-color: #fff;
    padding: 6px 25px 6px 10px;
    border-radius: 50px;
    border: 1px solid #c73343;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
  }

  .multipleSelect .multipleSelectDrop {
    position: absolute;
    white-space: normal;
    top: 32px;
    background: #fff;
    width: 200%;
    display: none;
    opacity: 0;
    transition: opacity 0.2s;
    /*max-height: 200px;*/
    /*overflow: auto;*/
    box-shadow: 0px 0px 5px 0px #ccc;
    border-radius: 4px;
  }

  .multipleSelect .multipleSelectDrop .multipleSelectSelectData {
    padding: 10px 6px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    display: inline-flex;
    width: 45%;
    align-items: center;
  }

  .multipleSelectSelectData input {
    margin-right: 10px;
  }
  /*.multipleSelect .multipleSelectDrop .multipleSelectSelectData.active::after{*/
  /*  content: '√';*/
  /*  font-family: "微软雅黑", "Arial";*/
  /*  position: absolute;*/
  /*  right: 5px;*/
  /*}*/
  /*  .multipleSelect .multipleSelectDrop .multipleSelectSelectData.active {
      color: #C73343;
    } */
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData:hover {
    /*color: #fff;*/
    cursor: pointer;
    /* background: #f1f1f1; */
  }

  .multipleSelectArror {
    position: absolute;
    right: 8px;
    top: 9px;
    color: #c73343;
    font-size: 10px;
    font-weight: bold;
  }

  @media screen and (max-width: 1370px) {
    .multipleSelect {
      max-width: 200px !important;
      min-width: 200px !important;
    }
  }
  .noWrap {
    width: 90%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  input[type="checkbox"] {
    width: 12px;
    height: 12px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 12px;
    position: relative;
    border: none;
  }

  input[type="checkbox"]::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #cacdcf;
    border-radius: 2px;
  }

  input[type="checkbox"]:checked::before {
    content: "\2713";
    background-color: #c73343;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border: 1px solid #c73343;
    font-size: 12px;
    font-weight: bold;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/hospitalSelect.vue